import React from 'react';
import './Contact.css';
import { FaFacebook, FaInstagram, FaTiktok, FaTelegramPlane, FaEnvelope, FaPhone } from 'react-icons/fa';

const Contact = () => {
  return (
    <section className="static-page">
      <h1>Contact Us</h1>
      <p>
        If you have questions, suggestions, or inquiries about MyApoti, we’re here to help.
        Reach out to us and we'll respond as soon as possible.
      </p>

      <p>
        <FaEnvelope className="icon" /> Email:{" "}
        <strong>
          <a href="mailto:info@myapoti.com" className="contact-link">info@myapoti.com</a>
        </strong>
      </p>

      <p>
        <FaPhone className="icon" /> Phone:{" "}
        <strong>
          <a href="tel:07054873626" className="contact-link">07054873626</a>
        </strong>
      </p>

      <p className="socials">
        <FaFacebook className="icon" />
        <a href="https://facebook.com/myapoti" target="_blank" rel="noopener noreferrer" className="contact-link">
          Facebook: myapoti
        </a>
      </p>

      <p className="socials">
        <FaTiktok className="icon" />
        <a href="https://tiktok.com/@myapoti" target="_blank" rel="noopener noreferrer" className="contact-link">
          TikTok: @myapoti
        </a>
      </p>

      <p className="socials">
        <FaInstagram className="icon" />
        <a href="https://instagram.com/myapoti" target="_blank" rel="noopener noreferrer" className="contact-link">
          Instagram: myapoti
        </a>
      </p>

      <p className="socials">
        <FaTelegramPlane className="icon" />
        <a href="https://t.me/myapoti" target="_blank" rel="noopener noreferrer" className="contact-link">
          Telegram: https://t.me/myapoti
        </a>
      </p>

      <p>
        We appreciate your interest in helping us improve drug accessibility across Nigeria.
      </p>
    </section>
  );
};

export default Contact;
